import dynamic from "next/dynamic";
const ProductCardsSideBySideTextAndAssetComponent = dynamic(()=>import("./product-cards-side-by-side-text-and-asset-component"));
import ProductCardsSideBySideTextAndAssetConfig from "./product-cards-side-by-side-text-and-asset-config";
import ProductCardsSideBySideTextAndAssetAdvancedConfig from "./product-cards-side-by-side-text-and-asset-advanced-config";
export default {
    ProductCardsSideBySideTextAndAssetComponent,
    ProductCardsSideBySideTextAndAssetConfig,
    ProductCardsSideBySideTextAndAssetAdvancedConfig
};
